import { Button, Checkbox, ConfigProvider, Form, Input, InputNumber, Modal, Radio, Select, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { addExport, fetchMappingMedia, modExport } from '../../apis/export'
import { fetchMappingKeys } from '../../apis/source'
import { FormButton, FormItemWrapper } from './exportList.styled'
import { TRANS_TYPE } from '../../constants/TransType'
import { transForm } from './conf'

function ExportModal (props) {
  const { title, open, editMode, data, groupsOption, setModalProps, params, allBrands = [] } = props
  const { handleFetchParams } = params
  const { t: ln_t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [dataTypeOpt, setDataTypeOpt] = useState([])
  const [mediaOpt, setMediaOpt] = useState()
  const [group, setGroup] = useState()
  const [brandOpt, setBrandOpt] = useState()
  const [isMapping, setIsMapping] = useState(false)
  const [transType, setTransType] = useState()
  const [additionalInfo, setAdditionalInfo] = useState({})
  const [form] = Form.useForm()
  const transFormItems = transForm[transType] || transForm.def

  const defPlaceholder = (name, type) => {
    const message = type === 'input' ? ln_t('util.pleaseEnter') : type === 'select' ? ln_t('util.pelaseSelect') : ''
    return `${message} ${ln_t(`export.${name}`)}`
  }
  const defConfig = (name, type, required = true, labelName) => ({ name, label: ln_t(`export.${labelName || name}`), rules: [{ required, message: defPlaceholder(labelName || name, type) }] })

  const handleGroupChange = async (groupId, reset = true) => {
    setGroup(groupId)
    const brandInGroup = [...allBrands].filter(i => i.groupId === groupId)
    setBrandOpt([{ value: 'all', label: 'ALL' }, ...brandInGroup?.map(i => ({ value: i.id, label: i.name }))])
    const res = await fetchMappingKeys({ maxResults: 500, groupIds: `0,${groupId}` })
    if (res?.status === 200) setDataTypeOpt(res?.data?.map(i => ({ value: i.id, label: i.name })))
    reset && form.setFieldsValue({ permission: 'all', dataType: undefined })
  }

  const handleTransChange = e => {
    setTransType(e)
    const updateForm = transForm[e]?.filter(i => i.defaultValue)?.reduce((all, i) => ({ ...all || {}, [i.key]: i.defaultValue }), {})
    form.setFieldsValue(updateForm)
  }

  const handlePermissionChange = e => {
    const currentValue = form.getFieldValue('permission') || []
    form.setFieldValue('permission', e === 'all' ? ['all'] : currentValue.filter(i => i !== 'all'))
  }

  const handleChangeCookieMapping = e => {
    const value = e?.target?.checked
    const transType = form.getFieldValue('transType')
    setIsMapping(value)
    if (!value) form.setFieldValue('mappingMedia', null)
    if (value && transType === TRANS_TYPE.META) {
      setTransType(undefined)
      form.setFieldValue('transType', null)
    }
  }

  const handleClose = () => {
    form.resetFields()
    setTransType()
    setGroup()
    setModalProps({})
  }
  const successCallback = msg => {
    message.success(msg)
    handleFetchParams('initPage', {})
    handleClose()
  }
  const closeWithCheck = () => {
    if (!editMode || !data.accessToken || form.getFieldValue('accessToken') === data.accessToken) return handleClose()
    Modal.confirm({
      title: ln_t('message.info.tokenNotSaved'),
      onOk: handleClose
    })
  }

  const handleAdd = async reqBody => {
    const result = await addExport(reqBody)
    if (result?.status === 201) successCallback(ln_t('message.success.create'))
  }
  const handleMod = async reqBody => {
    const result = await modExport(data.id, reqBody)
    if (result?.status === 200) successCallback(ln_t('message.success.modify'))
  }

  const formatPayload = ({ permission, isMapping, ...value }) => {
    const transKeys = transFormItems.map(i => i.key)
    const information = {}; const others = {}
    Object.entries(value).forEach(([key, val]) => { transKeys.includes(key) ? information[key] = val : others[key] = val })
    return { ...others, information, isMapping: isMapping ? 1 : 0, permission: permission.includes('all') ? null : permission.join() }
  }
  const onFinish = async value => {
    const reqBody = formatPayload(value)
    setLoading(true)
    const api = editMode ? handleMod : handleAdd
    // if (api) console.log(reqBody)
    await api(reqBody)
    setLoading(false)
  }

  const getMappingMedia = async () => {
    const res = await fetchMappingMedia({ maxResults: 5000 })
    if (res?.status === 200) setMediaOpt(res?.data?.map(i => ({ value: `${i.mediaId}`, label: i.mediaName })))
  }

  useEffect(() => {
    if (!open) return
    getMappingMedia()
    const { permission, ...others } = data || {}
    const brands = editMode ? { permission: permission ? permission?.split(',')?.map(i => Number(i)) : 'all' } : {}
    form.setFieldsValue({ ...others, ...brands })
    data?.groupId && handleGroupChange(data?.groupId, false)
    data?.transType && setTransType(data?.transType)
    data?.isMapping && setIsMapping(data?.isMapping)
  }, [open])

  const components = {
    input: props => <Input placeholder={props.placeholder} disabled={props?.disabled} />,
    inputPassword: props => <Input.Password placeholder={props.placeholder} disabled={props?.disabled} />,
    inputNumber: props => <InputNumber placeholder={props?.placeholder} precision={props?.precision === 'unlimited' ? undefined : props?.precision || 0} min={props?.min || 0} style={{ width: '100%' }} />,
    select: props => <Select showSearch optionFilterProp="label" placeholder={props.placeholder} disabled={props?.disabled} options={props?.options} />
  }

  return (
    <Modal title={title} open={open} onCancel={closeWithCheck} footer={null} width='1000px' style={{ top: '32px' }}>
      <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
        <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={false} style={{ margin: '24px 0px 16px' }}>
          <div style={{ display: 'flex' }}>
            <FormItemWrapper>
              <Form.Item {...defConfig('name', 'input')}>
                <Input placeholder={defPlaceholder('name', 'input')} />
              </Form.Item>
              <Form.Item {...defConfig('group', 'input')} name="groupId">
                <Select
                  showSearch
                  placeholder={defPlaceholder('group', 'select')}
                  options={groupsOption}
                  optionFilterProp="children"
                  onChange={e => handleGroupChange(e)}
                  />
              </Form.Item>
              <Form.Item {...defConfig('brand', 'select')} name="permission">
                <Select
                  mode="multiple"
                  showSearch
                  placeholder={defPlaceholder('brand', 'select')}
                  disabled={!group}
                  options={brandOpt}
                  optionFilterProp="children"
                  onSelect={handlePermissionChange}
                />
              </Form.Item>
              <Form.Item
                {...defConfig('dataType', 'select')}
                name="dataTypeId"
                dependencies={['transType']}
                rules={[
                  { required: true, message: ln_t('export.dataType') },
                  ({ getFieldValue }) => ({
                    validator (_, value) {
                      const transType = getFieldValue('transType')
                      if (!value || !transType || transType !== TRANS_TYPE.META) return Promise.resolve()
                      const selectedName = dataTypeOpt?.find(i => i.value === value)?.label
                      if (selectedName === 'phone' || selectedName === 'email' || selectedName === 'adid') return Promise.resolve()
                      return Promise.reject(new Error(ln_t('message.error.dataTypeMustBeEmailPhoneOrAdid')))
                    }
                  })
                ]}
              >
                <Select
                  showSearch
                  placeholder={defPlaceholder('dataType', 'select')}
                  disabled={!group}
                  options={dataTypeOpt}
                  optionFilterProp="children"
                />
              </Form.Item>
              <Form.Item {...defConfig('status', 'select')} initialValue={1}>
                <Radio.Group
                  options={[{ value: 1, label: ln_t('util.enable') }, { value: 0, label: ln_t('util.disable') }]}
                  optionType="button"
                  buttonStyle="solid"
                />
              </Form.Item>
              <Form.Item {...defConfig('isMapping', 'select', false)} label="" valuePropName="checked" style={{ margin: '-8px 0 12px' }}>
                <Checkbox onChange={handleChangeCookieMapping}>{ln_t('export.cookieMapping')}</Checkbox>
              </Form.Item>
              <Form.Item {...defConfig('media', 'select', isMapping)} name="mappingMedia">
                <Select
                  showSearch
                  placeholder={defPlaceholder('media', 'select')}
                  options={mediaOpt}
                  optionFilterProp="children"
                  disabled={!isMapping}
                />
              </Form.Item>
            </FormItemWrapper>

            <FormItemWrapper right>
              <Form.Item {...defConfig('transType', 'input')}>
                <Select
                  showSearch
                  placeholder={defPlaceholder('transType', 'select')}
                  options={Object.values(TRANS_TYPE)?.filter(i => i !== TRANS_TYPE.META || !isMapping).map(i => ({ value: i, label: i }))}
                  optionFilterProp="children"
                  onChange={handleTransChange}
                />
              </Form.Item>
              {transFormItems?.map(item => {
                const { key, labelName, type, required = true, disabled, tooltip, componentProps = {}, customComponent, noForm, dependency, options } = item
                const placeholderType = type.includes('input') ? 'input' : 'select'
                const formProps = { ...defConfig(key, placeholderType, required, labelName), disabled, tooltip: tooltip ? { ...tooltip, title: ln_t(`activity.${tooltip.title}`) } : undefined }
                const passProps = { form, placeholder: defPlaceholder(labelName || key, placeholderType), disabled, options, componentProps, dependency, formProps, setAdditionalInfo, additionalInfo, data }
                const component = customComponent || components[type]
                return noForm ? component(passProps) : <Form.Item key={key} {...formProps}>{component(passProps)}</Form.Item>
              })}
            </FormItemWrapper>
          </div>
          <FormButton>
            <Button type="default" onClick={closeWithCheck}>{ln_t('util.cancel')}</Button>
            <Button type="primary" htmlType="submit" loading={loading}>{ln_t('util.confirm')}</Button>
          </FormButton>
        </Form>
      </ConfigProvider>
    </Modal>
  )
}

export default ExportModal
